import React from "react";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function FactorType() {
  const { t } = useTranslation();
  const { factorSetting } = useSelector((state) => ({
    factorSetting: state.factor.factorSetting,
  }));
  return (
    <div className="d-flex flex-row flex-nowrap align-items-center">
      <Icons.CaretLeftFill size={15} className="mx-1 color-fill-primary" />
      <p className="color-fill-primary">
        {t(factorSetting.IsFactor ? "invoiceTitleMain" : "invoiceTitlePre")}
      </p>
    </div>
  );
}
